/* ADD Knowledge categories */
export const ADD_LESSON = "ADD_LESSON"
export const ADD_LESSON_SUCCESS = "ADD_LESSON_SUCCESS"
export const ADD_LESSON_CLEAN = "ADD_LESSON_CLEAN"
export const ADD_LESSON_ERROR = "ADD_LESSON_ERROR"
